import Button from "@client/controls/Button/component";
import Modal from "@client/controls/Modal/container";
import { FormStyleContext } from "@common/contexts/FormStyle";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import * as React from "react";

export interface OKModalMapProps {
  className?: string;
  isAdmin?: boolean;
  isCentered?: boolean;
  isInViewport?: boolean;
  isVisible: boolean;
  submitError?: string | null;
  title?: string;
  children?: any;
  okText?: string;
}

export interface OKModalActionProps {
  onClose?: () => any;
}

export type OKModalProps = OKModalActionProps & OKModalMapProps;

const OKModal = ({ isCentered, submitError, title, ...props }: OKModalProps) => {
  const i18n = useI18n();

  const { primaryButtonStyle } = React.useContext(FormStyleContext);

  return (
    <Modal
      {...props}
      className={classNames(props.className, { "admin _theme_": props.isAdmin })}
      isCentered={isCentered ?? true}
      isTopMost
    >
      <Modal.Header title={submitError ? i18n.failure : title} />
      <Modal.Body>
        {typeof props.children === "string" ? (
          <div dangerouslySetInnerHTML={{ __html: props.children }} />
        ) : (
          props.children
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onClose} style={primaryButtonStyle}>
          {props.okText || "OK"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OKModal;
